export const EndpointsConstant = {
  login: 'auth/authenticate',
  forgotPassword: 'auth/forgot-password',
  changePassword: 'auth/change-password',
  patient: 'patients',
  professional: 'professionals',
  clinic: 'clinics',
  appointments: 'appointments',
  specialties: 'specialties',
  address: 'address',
};
